// The one rule for "is the Mediablock connected", shared by the status bar, the system-status icons
// and the removal guard so they can never disagree. status.py writes 'Connected', 'Disconnected' or
// 'offline' (lowercase); '' is the schema default before it has ever run. The server applies the
// same list before accepting a removal request (bac-server utils/content-removal.js).
export const MEDIABLOCK_CONNECTED_STATUSES = ['Connected', 'Normal'];

export const isMediablockConnected = mediablock => MEDIABLOCK_CONNECTED_STATUSES.includes(mediablock?.status);
